import "./AppStyles.css";
// Components
import MyRoutes from "./routers/routes";

export default function App() {
  return (
    <div className="App">
      <MyRoutes />
    </div>
  );
}
